function euclideanAggregationWgsl(arraySize) {
    return `
        var sum = 0.0;
        for (var i = 0u; i < ${arraySize}; i = i + 1u) {
            sum = sum + distances[i] * distances[i] * computeInfo.weights[i] * computeInfo.weights[i];
        }
        return sqrt(sum);
    `;
}
;
function manhattanAggregationWgsl(arraySize) {
    return `
        var sum = 0.0;
        for (var i = 0u; i < ${arraySize}; i = i + 1u) {
            sum = sum + abs(distances[i]) * computeInfo.weights[i];
        }
        return sum;
    `;
}
export var WEBGSLAGGREGATION;
(function (WEBGSLAGGREGATION) {
    WEBGSLAGGREGATION["EUCLIDEAN"] = "EUCLIDEAN";
    WEBGSLAGGREGATION["MANHATTAN"] = "MANHATTAN";
})(WEBGSLAGGREGATION || (WEBGSLAGGREGATION = {}));
export const WEBGSLAGGREGATIONFUNCTIONS = {
    [WEBGSLAGGREGATION.EUCLIDEAN]: euclideanAggregationWgsl,
    [WEBGSLAGGREGATION.MANHATTAN]: manhattanAggregationWgsl
};
//# sourceMappingURL=webGPU-aggregation.js.map